module.exports = __webpack_public_path__ + "static/media/loader-bp.fff805b8.svg";